// GENERATED FILE - DO NOT MODIFY

export enum GetServiceRequestsSortColumnDto {
    UserName = "UserName",
    CompanyName = "CompanyName",
    Date = "Date",
    Status = "Status",
}